import { DriverRequiredActionItem } from '@/lib/api/company/drivers/useQueryDriverRequiredActions'

type Args = {
  companyId: string
  driverId: number
  /** Wybrany miesiąc w formacie YYYY-MM — ten sam, o który pytamy o zadania. */
  month: string
}

const monthRange = (month: string) => {
  const [year, monthNumber] = month.split('-').map(Number)
  const from = new Date(year, monthNumber - 1, 1)
  const to = new Date(year, monthNumber, 0)
  const pad = (value: number) => String(value).padStart(2, '0')
  return {
    from: `${from.getFullYear()}-${pad(from.getMonth() + 1)}-${pad(from.getDate())}`,
    to: `${to.getFullYear()}-${pad(to.getMonth() + 1)}-${pad(to.getDate())}`,
  }
}

/**
 * Ekran, na którym wykonuje się dane zadanie — znacznik przy kierowcy ma nie tylko mówić,
 * co zostało do zrobienia, ale też tam prowadzić, razem z właściwym kierowcą i miesiącem.
 *
 * Zwraca null dla zadania, dla którego nie ma sensownego celu — wtedy znacznik zostaje
 * samym oznaczeniem, bez klikania w nic.
 */
export function getDriverActionRoute(
  item: DriverRequiredActionItem,
  { companyId, driverId, month }: Args,
): string | null {
  const base = `/et/company/${companyId}/driverModule`

  switch (item.type) {
    case 'missingContract':
    case 'taxExemptExpired':
    case 'taxExemptUnder26Missing':
    case 'taxExemptAgeUnknown':
      return `${base}/basicData/driver/${driverId}`

    case 'violationsOutOfDate': {
      const { from, to } = monthRange(month)
      return `${base}/driver/${driverId}/violation-new/from/${from}/to/${to}`
    }

    case 'foreignActivityWithoutTrip': {
      const { from, to } = monthRange(month)
      return `${base}/driver/${driverId}/businessTrip/from/${from}/to/${to}`
    }

    case 'timesheetNotPrepared':
    case 'timesheetOutOfDate':
      return `${base}/timesheet/driver/${driverId}/month/${month}`

    default:
      return null
  }
}
